module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_7042.27f5f186.png";